<div class="eco-input-wrapper">
  @if (label) {
    <label for="ecoembes-input-text-{{ label }}" class="eco-input-label">
      {{ label | translate }}
      @if (isRequired()) {
        <span>*</span>
      }
    </label>
  }
  <input
    id="ecoembes-input-text-{{ label }}"
    type="text"
    pInputText
    class="w-full"
    [placeholder]="placeholder ? (placeholder | translate) : ''"
    [ngModel]="value"
    [disabled]="disabled"
    [ngClass]="{
      'ng-invalid ng-dirty': ngControl()?.invalid && ngControl()?.touched,
    }"
    (ngModelChange)="onValueChange($event)"
  />
  <app-eco-helper-text [ngControl]="ngControl()"></app-eco-helper-text>
</div>
